// Copyright 2026 Granite (granite.md). All rights reserved.
// Proprietary and confidential. Unauthorized copying is prohibited.

/**
 * Google Drive sign-ins started in the phone app (`POST /v1/drive/connect?client=mobile`): the
 * server starts their state with "app.", and the web callback hands code and state back to the
 * app, which finishes with its own session. Google only returns to this web address.
 */
export const phoneAppStatePrefix = "app.";

export function isPhoneAppDriveState(state: string | undefined): boolean {
  return state?.startsWith(phoneAppStatePrefix) === true;
}

/** The link that opens the phone app with the sign-in to finish. */
export function phoneAppDriveLink(code: string, state: string): string {
  return `granite://drive-callback?${new URLSearchParams({ code, state }).toString()}`;
}
